import { useEffect } from "react";
import { useAuth } from "../platform/AuthProvider";
import { api } from "../api";
import { core } from "./core";
import { logFacebookAttribution } from "./attribution";

/**
 * Mounts once near the app root: captures Facebook attribution, loads native
 * device identifiers, syncs the authenticated user onto the tracking singleton,
 * and installs the server-side tracker bridge for GTM.
 */
export function TrackingInitializer({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user: authUser, isLoaded: isAuthLoaded } = useAuth();

  // Capture Facebook attribution and native device identifiers on initial load
  useEffect(() => {
    logFacebookAttribution();
    core.loadNativeDeviceIds();
  }, []);

  useEffect(() => {
    installServerSideTracking();
    if (authUser) {
      core.userData = {
        id: authUser?.id,
        email: authUser?.email ?? "",
        first_name: authUser?.firstName ?? "",
        last_name: authUser?.lastName ?? "",
      };
    } else {
      core.userData = undefined;
    }
    if (isAuthLoaded) {
      core.initialized();
    }
  }, [isAuthLoaded, authUser]);
  return children;
}

const installServerSideTracking = () => {
  const serverTracker = (data: any) => {
    const ENDPOINT = '/tr/events';
    // Inject device identifiers at send time so they're always current —
    // GTM fires the tag synchronously but loadNativeDeviceIds resolves async,
    // so advertising_id may not have been in the dataLayer at tag-fire time.
    const advertisingId = core.deviceIds.advertising_id;
    const enrichedData = advertisingId ? {
      ...data,
      user_data: { ...data.user_data, advertising_id: advertisingId },
    } : data;
    console.log("[serverTracker]", data.event_name, { has_madid: !!advertisingId });
    try {
      api.post(ENDPOINT, {events: [enrichedData]});
      return true;
    } catch (e) {
      console.error('Tracker Failed:', e);
      return false;
    }
  };
  (window as any).serverTracker = serverTracker;
}
